/**
 * Whether the console's sidebar is folded to its icons, remembered on this
 * device, per product (each product's host keeps its own storage).
 *
 * A view preference rather than an account setting: it says how this
 * screen is arranged for the person in front of it, and a folded sidebar
 * changes nothing about where the console can go.
 */const KEY="console.sidebar";export function sidebarCollapsed(){try{return window.localStorage.getItem(KEY)==="collapsed";}catch(_unused){return false;}}export function rememberSidebarCollapsed(collapsed){try{if(collapsed){window.localStorage.setItem(KEY,"collapsed");}else{window.localStorage.removeItem(KEY);}}catch(_unused2){// A browser that refuses storage opens the sidebar next time, which is
// the default.
}}